export const parseQueryParameters = (parameters: object) => {
    let queryParams = '';
    let count = 0;
    
    for (const [key, value] of Object.entries(parameters)) {
        if(typeof value === 'undefined' || value === null){
            continue;
        }
        queryParams += (count === 0 ? '?' : '&') + `${key}=${value}`;
        count++; 
    }

    return queryParams;
}